import { Dropdown, Menu, Tabs } from 'antd';
import { other } from 'assets';
import { Button, LockStatus, Modal, Table } from 'components';
// 2025/08/25 承認エラーメッセージ出力 start
import { toast } from 'react-toastify';
// 2025/08/25 承認エラーメッセージ出力 end
import { ContainerChangeTime } from 'containers/GranttChart';
// 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
// import { CheckTools, StatusConfirm, userRole, WORKER_SCHEDULE_STATUS } from 'constant';
import {
  APPROVAL_FLG,
  CheckTools,
  RETRUNER_ROLE,
  RKY_CREATION_FLG,
  StatusConfirm,
  userRole,
} from 'constant';
// 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
import { KY_APPROVE_STATUS, STATUS_LOCKED } from 'constant/site';
import { layoutSelector } from 'containers/Layout/selectors';
// 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
// import { checkHasDate } from 'containers/TableGantt';
// 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end
import { useAppDispatch, useQueryParams } from 'hooks';
import { dayjs } from 'libs';
// 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
// import { flatMap, flattenDeep, isUndefined, uniqBy, uniqueId } from 'lodash';
import { flatMap, isEmpty, isUndefined, uniqBy, uniqueId } from 'lodash';
// 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
import ModalEditCheckInTime from 'pages/Home/Bo/BusinessDetail/ModalEditCheckInTime';
// 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
// import { businessDetailSelector } from 'pages/Home/Bo/BusinessDetail/selectors';
// import { getShopSchedulesWorkersChargeSiteList } from 'pages/Home/Bo/BusinessDetail/thunk';
// 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
import { userData } from 'pages/Login/selectors';
import { ContentStyled } from 'pages/ModalMock/ApproveRY/styles';

import GanttChart from 'pages/SiteDetail/GanttChart';
import {
  siteDetailSelector,
  siteTabSelector,
  siteUserStatusAdapterSelectors,
} from 'pages/SiteDetail/selectors';
import { TableForm } from 'pages/SiteDetail/TableForm';
import React, { FC, useCallback, useEffect, useMemo, useRef, useState, createContext } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { siteService } from 'services';
import * as Types from 'types';
// 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
// import { SiteCooperatorListTodayItem, UserStatuses, WorkerShift } from 'types';
import { UserStatuses, WorkerShift } from 'types';
// 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
import {
  getKYDataApproveBySiteManage,
  // 2025/02/25 FJ 3月分反映分 NO32 start
  getKYDataApproveGroupBySiteManage,
  // 2025/02/25 FJ 3月分反映分 NO32 end
  getStatusKy,
} from 'containers/Layout/thunk';
import { ParamsStatusForBuildingDetail } from 'pages/SiteDetail';
// 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
// import { setSiteUserStatus, updateStatusSkyCheck } from '../slice';
import { updateStatusSkyCheck } from '../slice';
// 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
import {
  getKy,
  // 2025/02/25 FJ 3月分反映分 NO32 start
  getKyGroup,
  // 2025/02/25 FJ 3月分反映分 NO32 end
  getPerformance,
  // 2025/02/25 FJ 3月分反映分 NO32 start
  getPerformanceGroup,
  // 2025/02/25 FJ 3月分反映分 NO32 end
  // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
  // getSiteShopUserSchedule,
  // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end
  getSiteCooperatorListToday,
  // 2025/02/25 FJ 3月分反映分 NO32 start
  getSiteFirstCooperatorListToday,
  // 2025/02/25 FJ 3月分反映分 NO32 end
  getSiteUserStatus,
  // 2025/02/25 FJ 3月分反映分 NO32 start
  getSiteUserGroupStatus,
  // 2025/02/25 FJ 3月分反映分 NO32 end
  getTodayFootingCheck,
  // 2025/02/25 FJ 3月分反映分 NO32 start
  getTodayFootingCheckGroup,
  // 2025/02/25 FJ 3月分反映分 NO32 end
  getTodaySafetyOrder,
  // 2025/02/25 FJ 3月分反映分 NO32 start
  getTodaySafetyOrderGroup,
  // 2025/02/25 FJ 3月分反映分 NO32 end
  getTodaySlingtool,
  // 2025/02/25 FJ 3月分反映分 NO32 start
  getTodaySlingtoolGroup,
  // 2025/02/25 FJ 3月分反映分 NO32 end
} from '../thunk';
import {
  CheckToolStyled,
  PointRiskStyled,
  SubmitStyled,
  TabStyled,
  WorkStatusStyled,
} from './styles';

type PropsWorkStatus = {
  dataWorkRisk: Types.WorkRisk[];
  loadingWorkRisk: boolean;
  currentMonth?: Date;
  satusLocked?: number;
  getStatusForBuildingDetail?: (params: ParamsStatusForBuildingDetail) => void;
};
const dataSiteDetailGlobal = React.createContext<{
  tabActive?: string | null;
  dataWorker: Types.UserStatuses[];
}>({
  tabActive: JSON.stringify({ id: 0, name: '' }),
  dataWorker: [],
});
type Params = {
  site_id: string;
  buildingId: string;
  rky_created_date?: string;
  entity?: string;
};

const actionsCallBack = React.createContext<any>(null);
// 2025/02/25 FJ 3月分反映分 NO32 start
const systemChangeDay: number = 20250401;
// 2025/02/25 FJ 3月分反映分 NO32 end
export const WorkStatus: FC<PropsWorkStatus> = React.memo(({ getStatusForBuildingDetail }) => {
  const query = useQueryParams();
  const history = useHistory();
  const [visibleApproveRY, setVisibleApproveRY] = useState<boolean>(false);
  const [visibleReturnRY, setVisibleReturnRY] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { LockStatusData, StatusKyData, KYDataApproveBySiteManageDate } =
    useSelector(layoutSelector);
  const { Performance } = useSelector(siteDetailSelector);

  // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
  // 2025/02/26 FJ 3月分反映分 NO32 start
  // const { buildingId, gyosya_code, gyosya_siten_code } = useParams<{
  //   buildingId: string;
  //   gyosya_code: string;
  //   gyosya_siten_code: string;
  // }>();
  const {
    site_id,
    buildingId,
    gyosya_code,
    gyosya_siten_code,
    first_gyosya_code,
    first_gyosya_siten_code,
  } = useParams<{
    site_id: string;
    buildingId: string;
    gyosya_code: string;
    gyosya_siten_code: string;
    first_gyosya_code: string;
    first_gyosya_siten_code: string;
  }>();
  // 2025/02/26 FJ 3月分反映分 NO32 start
  // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
  const { user_id, roleUser, cooperator_id: cooperatorIdUserLogin } = useSelector(userData);
  const currentMonthParams = query.get('currentMonth')
    ? dayjs(query.get('currentMonth')).format('YYYY-MM-DD')
    : dayjs().format('YYYY-MM-DD');
  // const currentDayParams = query.get('currentDay')
  //   ? dayjs(query.get('currentDay')).format('YYYY-MM-DD')
  //   : dayjs().format('YYYY-MM-DD');
  const { rky_created_date } = useParams<Params>();
  const rawDay = query.get('currentDay');

  const currentDayParams = rky_created_date
    ? dayjs(rky_created_date).format('YYYY-MM-DD')
    : rawDay
    ? dayjs(rawDay).format('YYYY-MM-DD')
    : dayjs().format('YYYY-MM-DD');

  const [dataWorker, setDataWorker] = useState<Types.UserStatuses[]>([]);
  const { SiteUserStatus, Ky, TodaySlingtool, TodayFootingCheck, TodaySafetyOrder } =
    useSelector(siteDetailSelector);
  const user_statuses = useSelector(siteUserStatusAdapterSelectors.selectAll);
  // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
  // const { ShopSchedulesWorkersChargeSiteList } = useSelector(businessDetailSelector);
  // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
  // const [statusBuilding, setStatusBuilding] =
  //   useState<Types.GetKYDataApproveBySiteManageResponse>();
  const dataTabs = useSelector(siteTabSelector);
  const [WorkerStatusTableData, setWorkerStatusTableData] = useState<{
    data: UserStatuses[];
    loading: boolean;
  }>({ data: [], loading: true });

  // 2023/10/10 Leading Win 作業員シフト表廃止対応 start
  const [className, setClassName] = useState<string>('body');
  // 2023/10/10 Leading Win 作業員シフト表廃止対応 end

  const cooperatorIdParams = useMemo(() => {
    if (roleUser === userRole.BO) {
      return cooperatorIdUserLogin ?? undefined;
    }
    // 2025/02/25 FJ 3月分反映分 NO32 start
    // if (query.get('cooperator_id')) {
    //   return query.get('cooperator_id') ?? undefined;
    // } else if (!!dataTabs?.length && dataTabs.length > 0) {
    //   return dataTabs[0]?.key ?? undefined;
    // }
    if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
      if (query.get('cooperator_id')) {
        return query.get('cooperator_id') ?? undefined;
      } else if (!!dataTabs?.length && dataTabs.length > 0) {
        return dataTabs[0]?.key ?? undefined;
      }
    } else {
      if (query.get('cooperator_code')) {
        return query.get('cooperator_code') ?? undefined;
      } else if (!!dataTabs?.length && dataTabs.length > 0) {
        return dataTabs[0]?.code ?? undefined;
      }
    }
    // 2025/02/25 FJ 3月分反映分 NO32 end
    return undefined;
  }, [roleUser, query, dataTabs, cooperatorIdUserLogin, currentDayParams]);

  const cooperatorName = useMemo<string>(() => {
    if (!dataTabs || dataTabs.length === 0) return '';

    const cooperatorId = query.get('cooperator_id') ?? '';
    const cooperatorCode = query.get('cooperator_code') ?? '';
    if (cooperatorId) {
      return dataTabs?.find((t) => String(t.key) === String(cooperatorId))?.header ?? '';
    }
    if (cooperatorCode) {
      return dataTabs?.find((t) => t.code === cooperatorCode)?.header ?? '';
    }
    return dataTabs[0]?.header ?? '';
  }, [dataTabs, query]);

  const getSiteUserStatusData = useCallback(
    // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
    // async (cooperator: SiteCooperatorListTodayItem[]) => {
    //   if (!cooperator) return;
    //   const dataUserStatus = await Promise.all(
    //     uniqBy(cooperator, (i) => i.cooperator_id).map((i) =>
    //       siteService
    //         .getSiteUserStatus({
    //           building_id: buildingId,
    //           target_date: dayjs(currentDayParams).format('YYYY-MM-DD'),
    //           cooperator_id: i.cooperator_id,
    //         })
    //         .then((res) => res.data)
    //     )
    //   );
    //   if (!dataUserStatus) return;
    //   let user_statuses: UserStatuses[][] = [];
    //   let total = 0;
    //   dataUserStatus.map((i) => {
    //     user_statuses.push(i.user_statuses);
    //     total += i.total;
    //   });
    //   dispatch(setSiteUserStatus({ user_statuses: user_statuses.flat(), total }));
    // },
    // [buildingId, currentDayParams, dispatch]
    async () => {
      // 2025/02/25 FJ 3月分反映分 NO32 start
      // await dispatch(
      //   getSiteUserStatus({
      //     building_id: buildingId,
      //     target_date: dayjs(currentDayParams).format('YYYY-MM-DD'),
      //     // 2023/03/18 Leading Win 複数業者コード紐付きNo78の対応 start
      //     gyosya_code,
      //     gyosya_siten_code,
      //     // 2023/03/18 Leading Win 複数業者コード紐付きNo78の対応 end
      //   })
      // );
      if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
        await dispatch(
          getSiteUserStatus({
            building_id: buildingId,
            target_date: dayjs(currentDayParams).format('YYYY-MM-DD'),
            // 2023/03/18 Leading Win 複数業者コード紐付きNo78の対応 start
            gyosya_code,
            gyosya_siten_code,
            // 2023/03/18 Leading Win 複数業者コード紐付きNo78の対応 end
          })
        );
      } else {
        await dispatch(
          getSiteUserGroupStatus({
            building_id: buildingId,
            target_date: dayjs(currentDayParams).format('YYYY-MM-DD'),
            first_cooperator_code: `${first_gyosya_code}-${first_gyosya_siten_code}`,
          })
        );
      }
      // 2025/02/25 FJ 3月分反映分 NO32 end
    },
    // 2023/03/18 Leading Win 複数業者コード紐付きNo78の対応 start
    [
      buildingId,
      currentDayParams,
      // 2025/02/27 FJ 3月分反映分 NO32 start
      // cooperatorIdParams,
      // 2025/02/27 FJ 3月分反映分 NO32 end
      dispatch,
      gyosya_code,
      gyosya_siten_code,
      first_gyosya_code,
      first_gyosya_siten_code,
    ]
    // 2023/03/18 Leading Win 複数業者コード紐付きNo78の対応 end
    // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
  );

  const fetchApi = useCallback(async () => {
    if (!currentDayParams) return;

    getStatusForBuildingDetail &&
      (await getStatusForBuildingDetail({
        building_id: buildingId,
        date: dayjs(currentDayParams).format('YYYY-MM-DD'),
        cooperator_id: cooperatorIdParams,
      }));
    // 2025/02/25 FJ 3月分反映分 NO32 start
    // dispatch(
    //   getKYDataApproveBySiteManage({
    //     building_id: buildingId,
    //     date: dayjs(currentDayParams).format('YYYY-MM-DD'),
    //     // 2023/03/19 Leading Win 複数業者コード紐付きNo42の対応 start
    //     ...(roleUser !== userRole.BO
    //       ? { cooperator_id: cooperatorIdParams }
    //       : { gyosya_code, gyosya_siten_code }),
    //     // 2023/03/19 Leading Win 複数業者コード紐付きNo42の対応 end
    //   })
    // );
    if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
      await dispatch(
        getKYDataApproveBySiteManage({
          building_id: buildingId,
          date: dayjs(currentDayParams).format('YYYY-MM-DD'),
          // 2023/03/19 Leading Win 複数業者コード紐付きNo42の対応 start
          ...(roleUser !== userRole.BO
            ? { cooperator_id: cooperatorIdParams }
            : { gyosya_code, gyosya_siten_code }),
          // 2023/03/19 Leading Win 複数業者コード紐付きNo42の対応 end
        })
      );
    } else {
      await dispatch(
        getKYDataApproveGroupBySiteManage({
          building_id: buildingId,
          date: dayjs(currentDayParams).format('YYYY-MM-DD'),
          ...(roleUser !== userRole.BO
            ? { first_cooperator_code: cooperatorIdParams ? cooperatorIdParams : '' }
            : { first_cooperator_code: `${first_gyosya_code}-${first_gyosya_siten_code}` }),
        })
      );
    }
    // 2025/02/25 FJ 3月分反映分 NO32 end

    // 2025/02/25 FJ 3月分反映分 NO32 start
    // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
    //dispatch(
    // const resultKy = await dispatch(
    //   // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end
    //   getKy({
    //     building_id: buildingId,
    //     date: dayjs(currentDayParams).format('YYYY-MM-DD'),
    //     // 2023/03/19 Leading Win 複数業者コード紐付きNo37の対応 start
    //     ...(roleUser !== userRole.BO
    //       ? { cooperator_id: cooperatorIdParams }
    //       : { gyosya_code, gyosya_siten_code }),
    //     // 2023/03/19 Leading Win 複数業者コード紐付きNo37の対応 end
    //   })
    // );
    let resultKy;
    if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
      // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
      //dispatch(
      resultKy = await dispatch(
        // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end
        getKy({
          building_id: buildingId,
          date: dayjs(currentDayParams).format('YYYY-MM-DD'),
          // 2023/03/19 Leading Win 複数業者コード紐付きNo37の対応 start
          ...(roleUser !== userRole.BO
            ? { cooperator_id: cooperatorIdParams }
            : { gyosya_code, gyosya_siten_code }),
          // 2023/03/19 Leading Win 複数業者コード紐付きNo37の対応 end
        })
      );
    } else {
      resultKy = await dispatch(
        // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end
        getKyGroup({
          building_id: buildingId,
          date: dayjs(currentDayParams).format('YYYY-MM-DD'),
          ...(roleUser !== userRole.BO
            ? { first_cooperator_code: cooperatorIdParams ? cooperatorIdParams : '' }
            : { first_cooperator_code: `${first_gyosya_code}-${first_gyosya_siten_code}` }),
        })
      );
    }
    // 2025/02/25 FJ 3月分反映分 NO32 end
    if (roleUser !== userRole.BO) {
      // 2025/02/25 FJ 3月分反映分 NO32 start
      // await dispatch(
      //   getSiteUserStatus({
      //     building_id: buildingId,
      //     target_date: dayjs(currentDayParams).format('YYYY-MM-DD'),
      //     cooperator_id: cooperatorIdParams,
      //   })
      // );
      if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
        await dispatch(
          getSiteUserStatus({
            building_id: buildingId,
            target_date: dayjs(currentDayParams).format('YYYY-MM-DD'),
            cooperator_id: cooperatorIdParams,
          })
        );
      } else {
        await dispatch(
          getSiteUserGroupStatus({
            building_id: buildingId,
            target_date: dayjs(currentDayParams).format('YYYY-MM-DD'),
            first_cooperator_code: cooperatorIdParams ? cooperatorIdParams : '',
          })
        );
      }
      // 2025/02/25 FJ 3月分反映分 NO32 end
    }
    // 2025/02/25 FJ 3月分反映分 NO32 start
    // await dispatch(
    //   getTodaySlingtool({
    //     building_id: buildingId,
    //     today: dayjs(currentDayParams).format('YYYY-MM-DD'),
    //     // 2023/03/18 Leading Win 複数業者コード紐付きNo99の対応 start
    //     ...(roleUser !== userRole.BO
    //       ? { cooperator_id: cooperatorIdParams }
    //       : { gyosya_code, gyosya_siten_code }),
    //     // 2023/03/18 Leading Win 複数業者コード紐付きNo99の対応 end
    //   })
    // );
    if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
      await dispatch(
        getTodaySlingtool({
          building_id: buildingId,
          today: dayjs(currentDayParams).format('YYYY-MM-DD'),
          // 2023/03/18 Leading Win 複数業者コード紐付きNo99の対応 start
          ...(roleUser !== userRole.BO
            ? { cooperator_id: cooperatorIdParams }
            : { gyosya_code, gyosya_siten_code }),
          // 2023/03/18 Leading Win 複数業者コード紐付きNo99の対応 end
        })
      );
    } else {
      await dispatch(
        getTodaySlingtoolGroup({
          building_id: buildingId,
          today: dayjs(currentDayParams).format('YYYY-MM-DD'),
          ...(roleUser !== userRole.BO
            ? { first_cooperator_code: cooperatorIdParams ? cooperatorIdParams : '' }
            : { first_cooperator_code: `${first_gyosya_code}-${first_gyosya_siten_code}` }),
        })
      );
    }
    // 2025/02/25 FJ 3月分反映分 NO32 end
    // 2025/02/25 FJ 3月分反映分 NO32 start
    // await dispatch(
    //   getTodayFootingCheck({
    //     building_id: buildingId,
    //     today: dayjs(currentDayParams).format('YYYY-MM-DD'),
    //     // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
    //     ...(roleUser !== userRole.BO
    //       ? { cooperator_id: cooperatorIdParams }
    //       : { gyosya_code, gyosya_siten_code }),
    //     // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
    //   })
    // );
    if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
      await dispatch(
        getTodayFootingCheck({
          building_id: buildingId,
          today: dayjs(currentDayParams).format('YYYY-MM-DD'),
          // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 start
          ...(roleUser !== userRole.BO
            ? { cooperator_id: cooperatorIdParams }
            : { gyosya_code, gyosya_siten_code }),
          // 2023/03/18 Leading Win 複数業者コード紐付きNo96の対応 end
        })
      );
    } else {
      await dispatch(
        getTodayFootingCheckGroup({
          building_id: buildingId,
          today: dayjs(currentDayParams).format('YYYY-MM-DD'),
          ...(roleUser !== userRole.BO
            ? { first_cooperator_code: cooperatorIdParams ? cooperatorIdParams : '' }
            : { first_cooperator_code: `${first_gyosya_code}-${first_gyosya_siten_code}` }),
        })
      );
    }
    // 2025/02/25 FJ 3月分反映分 NO32 end
    // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
    const work_id_list: any = [];
    //if (getKy.fulfilled.match(resultKy) && resultKy?.payload?.ky_data) {
    if (
      (getKy.fulfilled.match(resultKy) || getKyGroup.fulfilled.match(resultKy)) &&
      resultKy?.payload?.ky_data
    ) {
      resultKy.payload.ky_data.map(async (k) => {
        if (k.work_type_id) {
          work_id_list.push({ work_id: `${k.work_type_id}` });
        }
      });
    }
    // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end
    // 2025/02/25 FJ 3月分反映分 NO32 start
    // await dispatch(
    //   getTodaySafetyOrder({
    //     building_id: buildingId,
    //     date: dayjs(currentDayParams).format('YYYY-MM-DD'),
    //     cooperator_id: cooperatorIdParams ?? '',
    //     // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
    //     work_id_list,
    //     // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end
    //   })
    // );
    if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
      await dispatch(
        getTodaySafetyOrder({
          building_id: buildingId,
          date: dayjs(currentDayParams).format('YYYY-MM-DD'),
          cooperator_id: cooperatorIdParams ?? '',
          // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
          work_id_list,
          // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end
        })
      );
    } else {
      await dispatch(
        getTodaySafetyOrderGroup({
          building_id: buildingId,
          date: dayjs(currentDayParams).format('YYYY-MM-DD'),
          ...(roleUser !== userRole.BO
            ? { first_cooperator_code: cooperatorIdParams ? cooperatorIdParams : '' }
            : { first_cooperator_code: `${first_gyosya_code}-${first_gyosya_siten_code}` }),
          work_id_list,
        })
      );
    }
    // 2025/02/25 FJ 3月分反映分 NO32 end

    // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
    // if (roleUser === userRole.BO) {
    //   dispatch(
    //     getShopSchedulesWorkersChargeSiteList({
    //       building_id: buildingId,
    //       date: dayjs(currentDayParams).format('YYYY-MM-DD'),
    //     })
    //   );
    // }
    // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
    if (roleUser !== userRole.CM) {
      // 2025/02/25 FJ 3月分反映分 NO32 start
      // dispatch(
      //   getPerformance({
      //     building_id: buildingId,
      //     // 2023/03/20 Leading Win 複数業者コード紐付きNo51の対応 start
      //     ...(roleUser !== userRole.BO
      //       ? { cooperator_id: cooperatorIdParams }
      //       : { gyosya_code, gyosya_siten_code }),
      //     // 2023/03/20 Leading Win 複数業者コード紐付きNo51の対応 end
      //     worked_date: dayjs(currentDayParams).format('YYYY-MM-DD'),
      //   })
      // );
      if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
        dispatch(
          getPerformance({
            building_id: buildingId,
            // 2023/03/20 Leading Win 複数業者コード紐付きNo51の対応 start
            ...(roleUser !== userRole.BO
              ? { cooperator_id: cooperatorIdParams }
              : { gyosya_code, gyosya_siten_code }),
            // 2023/03/20 Leading Win 複数業者コード紐付きNo51の対応 end
            worked_date: dayjs(currentDayParams).format('YYYY-MM-DD'),
          })
        );
      } else {
        dispatch(
          getPerformanceGroup({
            building_id: buildingId,
            ...(roleUser !== userRole.BO
              ? { first_cooperator_code: cooperatorIdParams ? cooperatorIdParams : '' }
              : {
                  first_cooperator_code: `${first_gyosya_code}-${first_gyosya_siten_code}`,
                }),
            worked_date: dayjs(currentDayParams).format('YYYY-MM-DD'),
          })
        );
      }
      // 2025/02/25 FJ 3月分反映分 NO32 end
    }
  }, [
    buildingId,
    cooperatorIdParams,
    currentDayParams,
    dispatch,
    getStatusForBuildingDetail,
    roleUser,
    // 2025/02/27 FJ 3月分反映分 NO32 start
    first_gyosya_code,
    first_gyosya_siten_code,
    gyosya_code,
    gyosya_siten_code,
    // 2025/02/27 FJ 3月分反映分 NO32 end
  ]);

  const checkStatusButtonAproveAndShowText = useMemo(() => {
    let disableCM = true;
    let disableDTC = true;
    let disableReturnBtn = true;
    let textCM = '未承認';
    let textDTC = '未確認あり';
    let textReturn = '差戻';

    let text = '';
    let lock = false;
    let worker_check_flag, director_approval_flag, manager_approval_flag;
    if (StatusKyData) {
      worker_check_flag = StatusKyData.worker_check_flag;
      director_approval_flag = StatusKyData.director_approval_flag;
    }

    if (KYDataApproveBySiteManageDate) {
      manager_approval_flag = KYDataApproveBySiteManageDate.site_manager_approval_flag;
    }

    if (roleUser === userRole.DTC) {
      if (worker_check_flag !== 1) {
        switch (worker_check_flag) {
          case 0:
            textDTC = '未確認あり'; //
            text = '';
            lock = false;
            break;
          case 2:
            textDTC = '未作成あり';
            text = '';
            lock = false;
            break;
          case 3:
            textDTC = '未承認';
            text = '';
            lock = false;
            break;
          default:
            textDTC = '未確認あり';
            text = '';
            lock = false;
            break;
        }
        disableDTC = true;
      } else {
        switch (director_approval_flag) {
          case 0:
            textDTC = '承認する';
            text = 'RKY未承認';
            lock = false;
            disableDTC = false;
            break;
          case 1:
            textDTC = '承認済み';
            text = 'RKY承認済';
            lock = true;
            disableDTC = true;
            textReturn = '承認済のため差戻できません';
            disableReturnBtn = true;
            break;
          case 2:
            textDTC = '承認済み';
            text = 'RKY承認済';
            lock = true;
            disableDTC = true;
            textReturn = '承認済のため差戻できません';
            disableReturnBtn = true;
            break;
          default:
            textDTC = '承認する';
            text = '';
            lock = false;
            disableDTC = false;
            break;
        }
      }

      if (!manager_approval_flag) {
        textCM = '未承認';
        disableCM = true;
      } else {
        textCM = '承認済み';
        disableCM = true;
      }

      // if (Ky?.data?.approval_flag == APPROVAL_FLG.KantokuApprovaled) {
      if (
        Ky?.data?.approval_flag == APPROVAL_FLG.KantokuApprovaled ||
        Ky?.data?.approval_flag == APPROVAL_FLG.KanrishaApprovaled
      ) {
        textReturn = '承認済のため差戻できません';
        disableReturnBtn = true;
      } else if (Ky?.data?.approval_flag == APPROVAL_FLG.Returned) {
        textDTC = '差戻中のため承認できません';
        disableDTC = true;
        textReturn = '差戻済';
        disableReturnBtn = true;
      } else if (currentDayParams && dayjs(currentDayParams).isSame(dayjs(), 'day')) {
        if (isEmpty(Ky?.data?.ky_data)) {
          textReturn = '未作成あり';
          disableReturnBtn = true;
        } else if (Ky.data?.rky_creation_flg === RKY_CREATION_FLG.Submitted) {
          textReturn = '差戻する';
          disableReturnBtn = false;
        }
      } else if (currentDayParams && !dayjs(currentDayParams).isSame(dayjs(), 'day')) {
        textReturn = '本日分のみ差戻が可能です';
        disableReturnBtn = true;
      }
    } else if (roleUser === userRole.CM) {
      if (!director_approval_flag) {
        textDTC = '未承認';
        disableDTC = true;
      } else {
        textDTC = '承認済み';
        disableDTC = true;
      }

      if (!director_approval_flag && !manager_approval_flag) {
        textCM = '未承認';
        text = '';
        lock = false;
        disableCM = true;
      } else if (director_approval_flag === 1 && !manager_approval_flag) {
        textCM = '承認する';
        text = 'RKY未承認';
        lock = false;
        disableCM = false;
      } else if (manager_approval_flag === 1) {
        textCM = '承認済み';
        text = 'RKY承認済';
        lock = true;
        disableCM = true;
      } else {
        textCM = '未承認';
        text = '';
        lock = false;
        disableCM = true;
      }
    } else if (roleUser === userRole.BO) {
      if (!director_approval_flag) {
        textDTC = '未承認';
        disableDTC = true;
      } else {
        textDTC = '承認済み';
        disableDTC = true;
      }

      if (!manager_approval_flag) {
        textCM = '未承認';
        disableCM = true;
      } else {
        textCM = '承認済み';
        disableCM = true;
      }
    }
    return { disableCM, disableDTC, disableReturnBtn, textCM, textDTC, textReturn, text, lock };
  }, [StatusKyData, KYDataApproveBySiteManageDate, roleUser, Ky, Ky?.data, Ky?.data?.ky_data]);

  const updateRkyCheckStatus = useCallback(
    async (indexTable: number) => {
      const {
        user_id,
        first_company_code,
        second_company_code,
        third_company_code,
        cooperator_id,
      } = WorkerStatusTableData.data[indexTable];
      const first_cooperator_id = query.get('cooperator_id') ?? '';
      try {
        await siteService.updateRkyCheckStatus({
          user_id,
          date: currentDayParams,
          building_id: buildingId,
          today_ky_tables_id: Ky.data?.ky_id.toString() ?? '',
          cooperator_code: third_company_code || second_company_code || first_company_code,
          first_cooperator_code: first_company_code,
          cooperator_id,
          first_cooperator_id,
          ky_work_id_list:
            Ky.data?.ky_data.map((item) => ({
              work_id: item.work_type_id.toString(),
            })) ?? [],
        });
      } catch (e) {
        console.error(e);
      }
    },
    [WorkerStatusTableData, buildingId, currentDayParams]
  );
  const checkShowSlingtoolAndFootingcheck = useCallback(
    ({ all_items_check_status, disuse_check_status }) => {
      let isShowContent = false;
      let textStatus: string | JSX.Element = '';
      if (all_items_check_status === 0 && disuse_check_status === 0) {
        textStatus = <div className="ant-empty-normal">データがありません</div>;
      }
      if (all_items_check_status === 0 && disuse_check_status === 1) {
        textStatus = '不使用に設定されています';
      }
      if (all_items_check_status === 1 && disuse_check_status === 0) {
        isShowContent = true;
      }
      return { isShowContent, textStatus };
    },
    []
  );
  // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
  // useEffect(() => {
  //   (async () => {
  //     if (roleUser !== userRole.BO) {
  //       buildingId &&
  //         currentMonthParams &&
  //         (await dispatch(
  //           getSiteShopUserSchedule({ building_id: buildingId, date: currentMonthParams })
  //         ));
  //       return;
  //     }
  //   })();
  // }, [buildingId, currentMonthParams, dispatch, roleUser]);
  // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end

  useEffect(() => {
    fetchApi();
  }, [fetchApi]);

  useEffect(() => {
    (async () => {
      // 2025/02/25 FJ 3月分反映分 NO32 start
      // if (roleUser === userRole.BO) {
      //   // 2023/10/10 Leading Win 作業員シフト表廃止対応 start
      //   setClassName('bobody');
      //   // 2023/10/10 Leading Win 作業員シフト表廃止対応 end
      //   const listCooperatotToday = await dispatch(
      //     getSiteCooperatorListToday({ building_id: buildingId, date: currentDayParams })
      //   );
      //   if (getSiteCooperatorListToday.fulfilled.match(listCooperatotToday)) {
      //     // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
      //     // getSiteUserStatusData(listCooperatotToday.payload.cooperators);
      //     getSiteUserStatusData();
      //     // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
      //   }
      // } else {
      //   await dispatch(
      //     getSiteCooperatorListToday({ building_id: buildingId, date: currentDayParams })
      //   );
      // }
      if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
        if (roleUser === userRole.BO) {
          // 2023/10/10 Leading Win 作業員シフト表廃止対応 start
          setClassName('bobody');
          // 2023/10/10 Leading Win 作業員シフト表廃止対応 end
          const listCooperatotToday = await dispatch(
            getSiteCooperatorListToday({ building_id: buildingId, date: currentDayParams })
          );
          if (getSiteCooperatorListToday.fulfilled.match(listCooperatotToday)) {
            // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
            // getSiteUserStatusData(listCooperatotToday.payload.cooperators);
            getSiteUserStatusData();
            // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
          }
        } else {
          await dispatch(
            getSiteCooperatorListToday({ building_id: buildingId, date: currentDayParams })
          );
        }
      } else {
        if (roleUser === userRole.BO) {
          setClassName('bobody');
          const listCooperatotToday = await dispatch(
            getSiteFirstCooperatorListToday({ building_id: buildingId, date: currentDayParams })
          );
          if (getSiteFirstCooperatorListToday.fulfilled.match(listCooperatotToday)) {
            getSiteUserStatusData();
          }
        } else {
          await dispatch(
            getSiteFirstCooperatorListToday({ building_id: buildingId, date: currentDayParams })
          );
        }
      }
      // 2025/02/25 FJ 3月分反映分 NO32 end
    })();
  }, [
    buildingId,
    currentDayParams,
    dispatch,
    getSiteUserStatusData,
    roleUser,
    // 2025/02/27 FJ 3月分反映分 NO32 start
    // fetchApi,
    // cooperatorIdParams,
    // 2025/02/27 FJ 3月分反映分 NO32 end
  ]);

  useEffect(() => {
    // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
    // const data: UserStatuses[] = [];
    // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
    let loading = SiteUserStatus.loading;

    // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
    //   if (ShopSchedulesWorkersChargeSiteList && roleUser === userRole.BO) {
    //     ShopSchedulesWorkersChargeSiteList?.data?.cooperators &&
    //       ShopSchedulesWorkersChargeSiteList.data.cooperators.map(({ users, ...d }) =>
    //         users.map((u) => {
    //           const findUser = user_statuses.filter((fu) => fu.user_id === u.user_id)[0];
    //           d &&
    //             u &&
    //             data.push({
    //               ...d,
    //               ...u,
    //               ...findUser,
    //             });
    //         })
    //       );
    //     setWorkerStatusTableData({ data: flatMap(user_statuses), loading });
    //   } else {
    //     user_statuses && setWorkerStatusTableData({ data: flatMap(user_statuses), loading });
    //   }
    // }, [ShopSchedulesWorkersChargeSiteList, SiteUserStatus.loading, roleUser, user_statuses]);
    user_statuses && setWorkerStatusTableData({ data: flatMap(user_statuses), loading });
  }, [SiteUserStatus.loading, roleUser, user_statuses]);
  // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end

  const tabRef = useRef<HTMLDivElement>(null);

  return (
    <dataSiteDetailGlobal.Provider value={{ dataWorker }}>
      <actionsCallBack.Provider
        value={{
          ...(roleUser === userRole.BO ? { getSiteUserStatusData } : { getSiteUserStatus }),
          // getSiteUserStatus,
          // getSiteUserStatusData,
          setDataWorker,
          getStatusForBuildingDetail,
          // getStatusApproveInbuilding,
          updateRkyCheckStatus,
          fetchApi,
        }}
      >
        <WorkStatusStyled>
          <Modal
            title="RKYを承認します。よろしいですか？"
            visible={visibleApproveRY}
            width={640}
            okButton={{
              text: '承認',
              onClick: async () => {
                try {
                  await siteService.updateKyAprove({
                    status:
                      roleUser === userRole.DTC
                        ? KY_APPROVE_STATUS.DTC_APPROVE
                        : KY_APPROVE_STATUS.CM_APPROVE,
                    ky_informations: [
                      {
                        building_id: buildingId,
                        cooperator_id: cooperatorIdParams,
                        date: currentDayParams,
                      },
                    ],
                  });
                  getStatusForBuildingDetail &&
                    getStatusForBuildingDetail({
                      building_id: buildingId,
                      date: dayjs(currentDayParams).format('YYYY-MM-DD'),
                      cooperator_id: cooperatorIdParams,
                    });
                  // 2025/08/25 承認エラーメッセージ出力 start
                  // 2025/12/02 施 匠対応一覧No.111 承認/差戻後工務店選択する場所までスクロールを移動する対応 start
                  window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                  });
                  // 2025/12/02 施 匠対応一覧No.111 承認/差戻後工務店選択する場所までスクロールを移動する対応 end
                } catch (error: any) {
                  const errMsg =
                    error?.response?.data?.message ??
                    error?.response?.data?.zOthers?.data?.message ??
                    'エラーが発生しました。';
                  toast.error(errMsg);
                  console.error(error);
                } finally {
                  setVisibleApproveRY(false);
                  await fetchApi();
                  // 2025/08/25 承認エラーメッセージ出力 end
                }
              },
            }}
            cancelButton={{ text: 'キャンセル', onClick: () => setVisibleApproveRY(false) }}
          >
            <ContentStyled>この操作は元に戻せません</ContentStyled>
          </Modal>
          <Modal
            title="RKY表を差戻します。"
            visible={visibleReturnRY}
            width={640}
            okButton={{
              text: '差戻',
              onClick: async () => {
                try {
                  await siteService.rkyReturn({
                    status: RETRUNER_ROLE.Director,
                    user_id: Number(user_id),
                    building_id: Number(buildingId),
                    site_id: Number(site_id),
                    date: dayjs(currentDayParams).format('YYYY-MM-DD'),
                    ...(String(cooperatorIdParams ?? '').includes('-')
                      ? { cooperator_code: String(cooperatorIdParams) }
                      : { cooperator_id: cooperatorIdParams }),
                  });
                  // 2025/08/25 承認エラーメッセージ出力 start
                  getStatusForBuildingDetail &&
                    getStatusForBuildingDetail({
                      building_id: buildingId,
                      date: dayjs(currentDayParams).format('YYYY-MM-DD'),
                      cooperator_id: cooperatorIdParams,
                    });
                  // 2025/12/02 施 匠対応一覧No.111 承認/差戻後工務店選択する場所までスクロールを移動する対応 start
                  window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                  });
                  // 2025/12/02 施 匠対応一覧No.111 承認/差戻後工務店選択する場所までスクロールを移動する対応 end
                } catch (error: any) {
                  const errMsg =
                    error?.response?.data?.message ??
                    error?.response?.data?.zOthers?.data?.message ??
                    'エラーが発生しました。';
                  toast.error(errMsg);
                  console.error(error);
                } finally {
                  setVisibleReturnRY(false);
                  await fetchApi();
                  // 2025/08/25 承認エラーメッセージ出力 end
                }
              },
            }}
            cancelButton={{ text: 'キャンセル', onClick: () => setVisibleReturnRY(false) }}
          >
            <ContentStyled>
              <span>
                {dayjs(Ky?.data?.timestamp).format('YYYY年MM月DD日（ddd）')}
                <br />
                {`${LockStatusData?.site_name}:`}
                <br />
                <span style={{ color: 'red' }}>{cooperatorName}</span>
                のRKYを差戻します。
              </span>
            </ContentStyled>
            <ContentStyled>よろしいでしょうか。</ContentStyled>

            <ContentStyled>
              <span style={{ color: 'red' }}>
                ※差戻後は、再提出まで、「承認する」ボタンが押せなくなりますので、ご注意ください。
              </span>
            </ContentStyled>
          </Modal>

          <div className="lock-status-container">
            <LockStatus
              text={LockStatusData?.site_name}
              date={currentDayParams}
              roleStatus={{
                text: checkStatusButtonAproveAndShowText.text,
                lock: checkStatusButtonAproveAndShowText.lock,
              }}
              lockStatus={{
                text: LockStatusData?.status_locked === STATUS_LOCKED.true ? '施錠済' : '未施錠',
                lock: LockStatusData?.status_locked === STATUS_LOCKED.true,
              }}
              code={LockStatusData?.building_code}
            />
          </div>
          {roleUser !== userRole.BO && <TableGantt />}
          {/* 2023/10/10 Leading Win 作業員シフト表廃止対応 start */}
          {/* <div className= "body mt-16"> */}
          <div className={className}>
            {/* 2023/10/10 Leading Win 作業員シフト表廃止対応 end */}
            <>
              <div
                ref={tabRef}
                className={`header-tab ${
                  roleUser === userRole.BO ? 'justify-end border-none position-absolute' : ''
                }`}
              >
                {(dataTabs && dataTabs.length > 0 && roleUser !== userRole.BO && (
                  <Tab
                    currentDay={currentDayParams}
                    currentMonth={currentMonthParams}
                    tabs={dataTabs || []}
                    clickTask={async (tab) => {
                      history.replace({
                        pathname: history.location.pathname,
                        search: query.get('currentMonth')
                          ? `?currentDay=${dayjs(currentDayParams).format(
                              'YYYY-MM-DD'
                            )}&currentMonth=${dayjs(currentMonthParams).format(
                              'YYYY-MM'
                            )}&cooperator_id=${tab?.key}&cooperator_code=${tab?.code}`
                          : `?currentDay=${dayjs(currentDayParams).format(
                              'YYYY-MM-DD'
                            )}&cooperator_id=${tab?.key}&cooperator_code=${tab?.code}`,
                      });
                    }}
                  />
                )) || <div />}
                <div className="mr-16">
                  <ContainerChangeTime
                    onChangeDate={async (date) => {
                      history.replace({
                        pathname: history.location.pathname,

                        search: query.get('currentMonth')
                          ? `?currentDay=${dayjs(date).format('YYYY-MM-DD')}&currentMonth=${dayjs(
                              currentMonthParams
                            ).format('YYYY-MM')}&cooperator_id=${cooperatorIdParams}`
                          : `?currentDay=${dayjs(date).format(
                              'YYYY-MM-DD'
                            )}&cooperator_id=${cooperatorIdParams}`,
                      });
                    }}
                    currentDateProps={currentDayParams}
                    enableDisableNextTime
                    showIconDate={true}
                    formatChangeDateTime={'YYYY/MM/DD'}
                    type="date"
                  />
                </div>
              </div>
              <div className="box-worker-status">
                <span className="header-box text-1">作業員状況 </span>
                <Table<Types.UserStatuses>
                  columns={
                    // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
                    // (roleUser === userRole.CM && columnsWorkerStatus.slice(0, 9)) ||
                    // 2025/02/25 FJ 3月分反映分 NO32 start
                    // (roleUser === userRole.CM && columnsWorkerStatus.slice(0, 11)) ||
                    (roleUser === userRole.CM && columnsWorkerStatus.slice(0, 9)) ||
                    // 2025/02/25 FJ 3月分反映分 NO32 end
                    // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
                    (roleUser === userRole.BO && columnsWorkerStatusBo) ||
                    columnsWorkerStatus
                  }
                  dataSource={WorkerStatusTableData.data}
                  loading={WorkerStatusTableData.loading}
                  rowKey={() => uniqueId()}
                />
              </div>
            </>

            {roleUser !== userRole.CM && (
              <div className="box-worker-status">
                <div className="header-box">
                  <span className="text-1">歩掛入力</span>
                  <span>
                    更新日時：
                    {Performance.data?.cooperator_work_list?.[0]?.updated_at &&
                      dayjs(Performance.data?.cooperator_work_list?.[0]?.updated_at).format(
                        'YYYY/MM/DD HH:mm'
                      )}
                  </span>
                </div>
                <TableForm currentDay={currentDayParams} />
              </div>
            )}
            <TableKy />
            <div className="box-worker-status">
              <div className="header-box">
                <span className="text-1">玉掛け用治具の点検確認</span>
                {checkShowSlingtoolAndFootingcheck({
                  all_items_check_status: TodaySlingtool.data?.all_items_check_status,
                  disuse_check_status: TodaySlingtool.data?.disuse_check_status,
                }).isShowContent && (
                  <span>
                    点検者：
                    {TodaySlingtool?.data?.inspection_user_name || TodaySlingtool?.data?.user_name}
                  </span>
                )}
              </div>
              {checkShowSlingtoolAndFootingcheck({
                all_items_check_status: TodaySlingtool.data?.all_items_check_status,
                disuse_check_status: TodaySlingtool.data?.disuse_check_status,
              }).isShowContent ? (
                <div className="box-sling-tool">
                  {TodaySlingtool?.data && (
                    <>
                      <div className="item-sling-tool">
                        <div className="text-item-sling-tool">ワイヤーロープ</div>
                        <CheckTool status={TodaySlingtool?.data?.wire_status} />
                      </div>
                      <div className="item-sling-tool">
                        <div className="text-item-sling-tool">シャックル</div>
                        <CheckTool status={TodaySlingtool?.data?.shackle_status} />
                      </div>
                      <div className="item-sling-tool">
                        <div className="text-item-sling-tool">ベルトスリング</div>
                        <CheckTool status={TodaySlingtool?.data?.belt_status} />
                      </div>
                      <div className="item-sling-tool">
                        <div className="text-item-sling-tool">クランプ</div>
                        <CheckTool status={TodaySlingtool?.data?.clamp_status} />
                      </div>
                    </>
                  )}
                </div>
              ) : (
                checkShowSlingtoolAndFootingcheck({
                  all_items_check_status: TodaySlingtool.data?.all_items_check_status,
                  disuse_check_status: TodaySlingtool.data?.disuse_check_status,
                }).textStatus
              )}
            </div>
            <div className="box-scaffold">
              <div className="box-test-scaffold scaffold-left">
                <div className="header-box">
                  <span className="text-1">足場使用前点検表</span>
                  {checkShowSlingtoolAndFootingcheck({
                    all_items_check_status: TodayFootingCheck.data?.all_items_check_status,
                    disuse_check_status: TodayFootingCheck.data?.disuse_check_status,
                  }).isShowContent && (
                    <span>
                      点検者：
                      {TodayFootingCheck.data?.inspection_user_name ||
                        TodayFootingCheck.data?.user_name}
                    </span>
                  )}
                </div>
                {checkShowSlingtoolAndFootingcheck({
                  all_items_check_status: TodayFootingCheck.data?.all_items_check_status,
                  disuse_check_status: TodayFootingCheck.data?.disuse_check_status,
                }).isShowContent ? (
                  <div className="box-list-test-scaffold">
                    {TodayFootingCheck.data &&
                      rowTodayFootingCHeck(TodayFootingCheck?.data?.all_items_check_status).map(
                        (item, index) => (
                          <div key={index} className="item-test-scaffold">
                            <div className="text-item-test-scaffold">{item.title}</div>
                            <CheckTool status={item?.status || ''} />
                          </div>
                        )
                      )}
                  </div>
                ) : (
                  checkShowSlingtoolAndFootingcheck({
                    all_items_check_status: TodayFootingCheck.data?.all_items_check_status,
                    disuse_check_status: TodayFootingCheck.data?.disuse_check_status,
                  }).textStatus
                )}
              </div>
              <div className="box-test-scaffold scaffold-right">
                <div>
                  <span className="text-1">安全指示事項</span>
                  <div className="box-list-test-scaffold">
                    {(TodaySafetyOrder.data &&
                      TodaySafetyOrder.data?.safetyorder_data.length > 0 &&
                      TodaySafetyOrder.data?.safetyorder_data.map((item, index) => (
                        <div key={index} className="item-test-scaffold">
                          <div className="text-item-test-scaffold">{item.safetyorder_content}</div>
                          {!isUndefined(item.check_status) && roleUser === userRole.BO && (
                            <StatusRky status={item.check_status} />
                          )}
                        </div>
                      ))) || <div className="ant-empty-normal">データがありません</div>}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-between pl-32 pr-32">
              <div className=" d-flex flex-column w-50">
                <span className="pb-8">是正内容</span>

                <div className="content-edit br-4 p-8 w-100">
                  {TodayFootingCheck?.data?.memo ?? ''}
                </div>
              </div>
              <div className="box-button-submit">
                {roleUser === userRole.DTC ? (
                  <div className="button-submit button-return">
                    <span className="title-button">工事担当者差戻 </span>
                    <Button
                      disabled={checkStatusButtonAproveAndShowText.disableReturnBtn}
                      onClick={() => {
                        if (checkStatusButtonAproveAndShowText.disableReturnBtn) {
                          return;
                        }
                        setVisibleReturnRY(true);
                      }}
                    >
                      {checkStatusButtonAproveAndShowText.textReturn}
                    </Button>
                  </div>
                ) : (
                  <></>
                )}
                <div className="button-submit button-left">
                  <span className="title-button">工事担当者承認 </span>
                  <Button
                    className={roleUser === userRole.CM || roleUser === userRole.BO ? 'hide' : ''}
                    disabled={checkStatusButtonAproveAndShowText.disableDTC}
                    onClick={() => {
                      if (checkStatusButtonAproveAndShowText.disableDTC) {
                        return;
                      }

                      setVisibleApproveRY(true);
                    }}
                  >
                    {checkStatusButtonAproveAndShowText.textDTC}
                  </Button>
                </div>
                <div className="button-submit button-right">
                  <span className="title-button">管理者承認</span>
                  <Button
                    className={roleUser === userRole.DTC || roleUser === userRole.BO ? 'hide' : ''}
                    disabled={checkStatusButtonAproveAndShowText.disableCM}
                    onClick={() => {
                      if (checkStatusButtonAproveAndShowText.disableCM) {
                        return;
                      }
                      setVisibleApproveRY(true);
                    }}
                  >
                    {checkStatusButtonAproveAndShowText.textCM}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </WorkStatusStyled>
      </actionsCallBack.Provider>
    </dataSiteDetailGlobal.Provider>
  );
});

export default WorkStatus;

// TableKy

const TableKy = React.memo(() => {
  const { Ky } = useSelector(siteDetailSelector);
  const { roleUser } = useSelector(userData);
  const maxPoint = () => {
    if (!Ky.data?.ky_data) {
      return 0;
    }
    return Math.max.apply(
      Math,
      Ky.data?.ky_data.map(function (item) {
        return item.risk_point;
      })
    );
  };

  return (
    <div className="box-worker-status">
      <div className="header-box">
        <span className="text-1">RKY</span>
        <span>制作者：{Ky?.data?.user_name}</span>
      </div>
      <Table<Types.KyDataItem>
        columns={columnsWorkRisk(maxPoint(), roleUser)}
        dataSource={Ky.data?.ky_data}
        loading={Ky.loading}
        rowKey={({ item_id }) => item_id}
      />
    </div>
  );
});

export type PropsTab = {
  tabs: ItemTab[];
  currentDay: Date | string;
  currentMonth: Date | string;
  clickTask?: (e: ItemTab) => void;
};
export type ItemTab = {
  header: string;
  title: string;
  key?: string;
  code?: string;
};

const { TabPane } = Tabs;

const Tab: FC<PropsTab> = React.memo(({ tabs, clickTask }) => {
  const query = useQueryParams();
  const currentMonthParams = query.get('currentMonth')
    ? dayjs(query.get('currentMonth')).format('YYYY-MM-DD')
    : dayjs().format('YYYY-MM-DD');
  const currentDayParams = query.get('currentDay')
    ? dayjs(query.get('currentDay')).format('YYYY-MM-DD')
    : dayjs().format('YYYY-MM-DD');
  const history = useHistory();
  const newTabs = uniqBy(tabs, (t) => t.key);
  const tabsKey = newTabs.map((t) => t.key);
  const isTabActive = tabsKey.includes(query.get('cooperator_id') ?? undefined);
  let tabDefault = isTabActive
    ? query.get('cooperator_id')
    : newTabs[0]?.key
    ? newTabs[0].key.toString()
    : '0';

  if (!isTabActive) {
    history.replace({
      pathname: history.location.pathname,
      search: `?cooperator_id=${tabDefault}&currentMonth=${dayjs(currentMonthParams).format(
        'YYYY-MM'
      )}&currentDay=${dayjs(currentDayParams).format('YYYY-MM-DD')}`,
    });
  }

  return (
    <TabStyled>
      {newTabs && (
        <Tabs
          defaultActiveKey={tabDefault || '0'}
          animated={false}
          onChange={(key) => {
            history.replace({
              pathname: history.location.pathname,
              search: `?cooperator_id=${key}&currentMonth=${dayjs(currentMonthParams).format(
                'YYYY-MM'
              )}&currentDay=${dayjs(currentDayParams).format('YYYY-MM-DD')}`,
            });
            clickTask && clickTask(newTabs.filter((t) => t.key === key)[0]);
          }}
        >
          {newTabs?.map((tab) => (
            <TabPane tab={tab.header} key={tab.key}>
              {tab.title}
            </TabPane>
          ))}
        </Tabs>
      )}
    </TabStyled>
  );
});

export type PropsTableGantt = {};
const TableGantt: FC<PropsTableGantt> = () => {
  const [dataChart, setDataChart] = useState<WorkerShift[]>([]);
  const query = useQueryParams();
  const currentMonth = query.get('currentMonth')
    ? dayjs(query.get('currentMonth')).format('YYYY-MM-DD')
    : dayjs().format('YYYY-MM-DD');
  const currentDayParams = query.get('currentDay')
    ? dayjs(query.get('currentDay')).format('YYYY-MM-DD')
    : dayjs().format('YYYY-MM-DD');
  const cooperatorId = query.get('cooperator_id');
  const cooperatorCode = query.get('cooperator_code');

  const [loading, setLoading] = useState<boolean>(false);
  const { SiteShopUserSchedule } = useSelector(siteDetailSelector);
  // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
  // const { buildingId } = useParams<{ buildingId: string }>();
  // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end
  const history = useHistory();
  // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
  // const cooperatorInMonth = useMemo(() => {
  //   return (
  //     SiteShopUserSchedule?.data?.cooperators?.filter(
  //       (i) =>
  //         !!i?.schedules?.find((i) =>
  //           dayjs(dayjs(currentMonth).startOf('month').format('YYYY-MM-DD')).isBetween(
  //             i.start_date,
  //             i.end_date
  //           )
  //         )
  //     ) ?? []
  //   );
  // }, [SiteShopUserSchedule?.data?.cooperators, currentMonth]);
  // const convertDataGantt = useCallback(async () => {
  //   if (!cooperatorInMonth) {
  //     return [];
  //   }

  //   let dataUserList = await Promise.all(
  //     cooperatorInMonth?.map((i) => {
  //       return siteService
  //         .getSiteCooperatorUsersSchedules({
  //           building_id: buildingId,
  //           cooperator_id: i.cooperator_id,
  //           work_type_id: i.work_type_id,
  //         })
  //         .then((res) => ({
  //           ...res.data,
  //           ...i,
  //         }));
  //     })
  //   );
  //   dataUserList = dataUserList.filter((i) => i);
  //   const dataConvert = dataUserList?.map((dataUser) => {
  //     const newData: WorkerShift[] = [];
  //     let statusWorkDate = '';
  //     if (!dataUser) return newData;

  //     if (dataUser?.schedules && dataUser.schedules.length > 1) {
  //       dataUser.schedules.map((itemSchedules, indexItemSchedules) => {
  //         statusWorkDate = checkHasDate({
  //           startDate: itemSchedules?.start_date,
  //           endDate: itemSchedules?.end_date,
  //         })
  //           ? 'primary'
  //           : 'disable';
  //         newData.push({
  //           id: `cooperator_id-${dataUser.cooperator_id}-${dataUser.work_type_name}-cooperator_company_name${dataUser.cooperator_company_name}-${indexItemSchedules}`,
  //           work_type: dataUser.work_type_name,
  //           text: dataUser.cooperator_company_name,
  //           start_date: dayjs(itemSchedules.start_date).format('YYYY-MM-DD'),
  //           end_date: dayjs(itemSchedules.end_date).format('YYYY-MM-DD'),
  //           className: statusWorkDate,
  //           parent: `cooperator_id-${dataUser.cooperator_id}-${dataUser.work_type_name}-cooperator_company_name${dataUser.cooperator_company_name}-split`,
  //           label: WORKER_SCHEDULE_STATUS[+dataUser.worker_schedule_status],
  //         });
  //       });
  //       // has worker_schedules_status
  //       if (dataUser.total > 0) {
  //         dataUser.users.map((dataUserItem) => {
  //           if (!!dataUserItem.schedules.length) {
  //             // if 2 schedules in 1 line
  //             if (dataUserItem.schedules.length > 1) {
  //               newData.push({
  //                 id: `${dataUser.cooperator_id}${dataUser.work_type_name}${dataUser.cooperator_company_name}_child_${dataUserItem.user_id}-split`,
  //                 text: dataUserItem.user_name,
  //                 className: statusWorkDate,
  //                 start_date: dayjs(currentMonth).format('YYYY-MM-DD'),
  //                 end_date: dayjs(currentMonth).format('YYYY-MM-DD'),
  //                 render: 'split',
  //                 parent: `cooperator_id-${dataUser.cooperator_id}-${dataUser.work_type_name}-cooperator_company_name${dataUser.cooperator_company_name}-split`,
  //                 isParent: true,
  //               });
  //               dataUserItem.schedules.map((itemSchedules, indexSchedules) => {
  //                 statusWorkDate = checkHasDate({
  //                   startDate: itemSchedules?.from_date,
  //                   endDate: itemSchedules?.to_date,
  //                 })
  //                   ? 'primary'
  //                   : 'disable';
  //                 newData.push({
  //                   id: `${dataUser.cooperator_id}${dataUser.work_type_name}${dataUser.cooperator_company_name}_child_${dataUserItem.user_id}-${indexSchedules}`,
  //                   text: dataUserItem.user_name,
  //                   start_date: dayjs(itemSchedules.from_date).format('YYYY-MM-DD'),
  //                   end_date: dayjs(itemSchedules.to_date).format('YYYY-MM-DD'),
  //                   className: statusWorkDate,
  //                   parent: `${dataUser.cooperator_id}${dataUser.work_type_name}${dataUser.cooperator_company_name}_child_${dataUserItem.user_id}-split`,
  //                 });
  //               });
  //               return;
  //             } else {
  //               // end if 2 schedules in 1 line
  //               dataUserItem.schedules.map((itemSchedules, indexSchedules) => {
  //                 statusWorkDate = checkHasDate({
  //                   startDate: itemSchedules?.from_date,
  //                   endDate: itemSchedules?.to_date,
  //                 })
  //                   ? 'primary'
  //                   : 'disable';
  //                 newData.push({
  //                   id: `${dataUser.cooperator_id}${dataUser.work_type_name}${dataUser.cooperator_company_name}_child_${dataUserItem.user_id}-${indexSchedules}`,
  //                   text: dataUserItem.user_name,
  //                   start_date: dayjs(itemSchedules.from_date).format('YYYY-MM-DD'),
  //                   end_date: dayjs(itemSchedules.to_date).format('YYYY-MM-DD'),
  //                   className: statusWorkDate,
  //                   parent:
  //                     dataUser.cooperator_id +
  //                     dataUser.work_type_name +
  //                     dataUser.cooperator_company_name,
  //                   label: '',
  //                 });
  //               });
  //             }
  //           }
  //         });
  //       }
  //     }
  //     // has childrent
  //     if (!!dataUser?.worker_schedule_status) {
  //       if (dataUser?.total > 0) {
  //         dataUser.users.map((dataUserItem) => {
  //           if (!!dataUserItem.schedules.length) {
  //             // if 2 schedules in 1 line
  //             if (dataUserItem.schedules.length > 1) {
  //               newData.push({
  //                 id: `${dataUser.cooperator_id}${dataUser.work_type_name}${dataUser.cooperator_company_name}_child_${dataUserItem.user_id}-split`,
  //                 text: dataUserItem.user_name,
  //                 className: statusWorkDate,
  //                 render: 'split',
  //                 start_date: dayjs(currentMonth).format('YYYY-MM-DD'),
  //                 end_date: dayjs(currentMonth).format('YYYY-MM-DD'),
  //                 parent:
  //                   dataUser.cooperator_id +
  //                   dataUser.work_type_name +
  //                   dataUser.cooperator_company_name,
  //                 isParent: true,
  //               });
  //               dataUserItem.schedules.map((itemSchedules, indexSchedules) => {
  //                 statusWorkDate = checkHasDate({
  //                   startDate: itemSchedules?.from_date,
  //                   endDate: itemSchedules?.to_date,
  //                 })
  //                   ? 'primary'
  //                   : 'disable';
  //                 newData.push({
  //                   id: `${dataUser.cooperator_id}${dataUser.work_type_name}${dataUser.cooperator_company_name}_child_${dataUserItem.user_id}-${indexSchedules}`,
  //                   text: dataUserItem.user_name,
  //                   start_date: dayjs(itemSchedules.from_date).format('YYYY-MM-DD'),
  //                   end_date: dayjs(itemSchedules.to_date).format('YYYY-MM-DD'),
  //                   className: statusWorkDate,
  //                   parent: `${dataUser.cooperator_id}${dataUser.work_type_name}${dataUser.cooperator_company_name}_child_${dataUserItem.user_id}-split`,
  //                 });
  //               });
  //               return;
  //             } else {
  //               dataUserItem.schedules.map((itemSchedules, indexSchedules) => {
  //                 statusWorkDate = checkHasDate({
  //                   startDate: itemSchedules?.from_date,
  //                   endDate: itemSchedules?.to_date,
  //                 })
  //                   ? 'primary'
  //                   : 'disable';
  //                 newData.push({
  //                   id: `${dataUser.cooperator_id}${dataUser.work_type_name}${dataUser.cooperator_company_name}_child_${dataUserItem.user_id}-${indexSchedules}`,
  //                   text: dataUserItem.user_name,
  //                   start_date: dayjs(itemSchedules.from_date).format('YYYY-MM-DD'),
  //                   end_date: dayjs(itemSchedules.to_date).format('YYYY-MM-DD'),
  //                   className: statusWorkDate,
  //                   parent:
  //                     dataUser.cooperator_id +
  //                     dataUser.work_type_name +
  //                     dataUser.cooperator_company_name,
  //                   label: '',
  //                 });
  //               });
  //             }
  //           }
  //         });
  //       }
  //     }
  //     if (dataUser?.schedules?.length > 1) {
  //       dataUser.schedules.map((itemSchedules, indexItemSchedules) => {
  //         statusWorkDate = checkHasDate({
  //           startDate: itemSchedules?.start_date,
  //           endDate: itemSchedules?.end_date,
  //         })
  //           ? 'primary'
  //           : 'disable';
  //         newData.push({
  //           id: `cooperator_id-${dataUser.cooperator_id}-${dataUser.work_type_name}-cooperator_company_name${dataUser.cooperator_company_name}-${indexItemSchedules}`,
  //           work_type: dataUser.work_type_name,
  //           text: dataUser.cooperator_company_name,
  //           start_date: dayjs(itemSchedules.start_date).format('YYYY-MM-DD'),
  //           end_date: dayjs(itemSchedules.end_date).format('YYYY-MM-DD'),
  //           className: statusWorkDate,
  //           parent: `cooperator_id-${dataUser.cooperator_id}-${dataUser.work_type_name}-cooperator_company_name${dataUser.cooperator_company_name}-split`,
  //           label: WORKER_SCHEDULE_STATUS[+dataUser.worker_schedule_status],
  //         });
  //       });
  //     } else {
  //       newData.push(
  //         ...dataUser.schedules.map((dataSchedule, i) => {
  //           statusWorkDate = checkHasDate({
  //             startDate: dataSchedule?.start_date,
  //             endDate: dataSchedule?.end_date,
  //           })
  //             ? 'primary'
  //             : 'disable';
  //           if (i === 0) {
  //             return {
  //               id:
  //                 dataUser.cooperator_id +
  //                 dataUser.work_type_name +
  //                 dataUser.cooperator_company_name,
  //               work_type: dataUser.work_type_name,
  //               text: dataUser.cooperator_company_name,
  //               start_date: dayjs(dataSchedule.start_date).format('YYYY-MM-DD'),
  //               end_date: dayjs(dataSchedule.end_date).format('YYYY-MM-DD'),
  //               className: statusWorkDate,
  //               open: false,
  //               label: WORKER_SCHEDULE_STATUS[+dataUser.worker_schedule_status],
  //             };
  //           }
  //           return {
  //             id: `${dataUser.cooperator_id}${dataUser.work_type_name}${dataUser.cooperator_company_name}${i}`,
  //             work_type: dataUser.work_type_name,
  //             text: dataUser.cooperator_company_name,
  //             start_date: dayjs(dataSchedule.start_date).format('YYYY-MM-DD'),
  //             end_date: dayjs(dataSchedule.end_date).format('YYYY-MM-DD'),
  //             className: checkHasDate({
  //               startDate: dataSchedule?.start_date,
  //               endDate: dataSchedule?.end_date,
  //             })
  //               ? 'primary'
  //               : 'disable',
  //             // parent: `${data[index].cooperator_id}${data[index].work_type_name}${data[index].cooperator_company_name}`,
  //             // label: '',
  //             label: WORKER_SCHEDULE_STATUS[+dataUser.worker_schedule_status],
  //           };
  //         })
  //       );
  //     }

  //     return newData;
  //   });

  //   setLoading(false);

  //   setDataChart(flattenDeep(dataConvert));
  // }, [buildingId, cooperatorInMonth, currentMonth]);

  // const getDataGrantTimeOut = useRef<NodeJS.Timeout>();

  // useEffect(() => {
  //   if (getDataGrantTimeOut.current) {
  //     clearTimeout(getDataGrantTimeOut.current);
  //   }
  //   getDataGrantTimeOut.current = setTimeout(() => {
  //     convertDataGantt();
  //   }, 100);
  // }, [convertDataGantt]);
  // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end

  return (
    <GanttChart
      dataChart={dataChart}
      setCurrentDate={(date) => {
        history.replace({
          pathname: history.location.pathname,
          search: `?cooperator_id=${cooperatorId}&cooperator_code=${cooperatorCode}&currentMonth=${dayjs(
            date
          ).format('YYYY-MM')}&currentDay=${dayjs(currentDayParams).format('YYYY-MM-DD')}`,
        });
      }}
      currentDate={currentMonth}
      loading={SiteShopUserSchedule.loading || loading}
    />
  );
};

const rowTodayFootingCHeck = (status?: number | string) => [
  {
    id: '0',
    title: '床材の損傷、取り外しはないか。躯体との離れは３００ｍｍ以下か。　',
    status,
  },
  {
    id: '1',
    title: '建地、床材、手すり、中桟、昇降階段等ゆるみ無く堅固に固定されているか。',
    status,
  },
  {
    id: '2',
    title: 'クランプ、番線、各所外れ止め金具等緊結材の損傷腐食ゆるみは無いか。',
    status,
  },
  {
    id: '3',
    title: '手すり・中桟等の取り外し及び脱落、腐食変形は無いか。高さは８５ｃｍ以上か。',
    status,
  },
  {
    id: '4',
    title: '建地と床材の隙間は１２cｍ未満となっているか。',
    status,
  },
  {
    id: '5',
    title: '柱脚部に沈下は無いか。正しく敷き板が設置されているか。',
    status,
  },
  {
    id: '6',
    title: '筋かい、控え、壁つなぎ等の取り外し、ゆるみはないか。',
    status,
  },
];
type kyStatusCheckProps = Pick<
  Types.UserStatuses,
  'ky_check' | 'safety_order_check_status' | 'rky_check_flag'
>;
const kyStatusCheck = ({
  ky_check,
  safety_order_check_status,
  rky_check_flag,
}: kyStatusCheckProps) => {
  if (rky_check_flag === StatusConfirm.CONFIRMED) {
    return StatusConfirm.DIRECTED;
  }
  if (rky_check_flag === StatusConfirm.UNCONFIRMED && ky_check === StatusConfirm.CONFIRMED) {
    return StatusConfirm.CONFIRMED;
  }
  return StatusConfirm.UNCONFIRMED;
};

// 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
// 「新規入場者」と「送り出し」0:未実施、1:実施済、2:承認済
const educationStatus = (educationStatus: string) => {
  if (educationStatus === '0') {
    return '未実施';
  } else if (educationStatus === '1') {
    return '実施済';
  } else if (educationStatus === '2') {
    return '承認済';
  }
};
// 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end

const columnsWorkerStatus = [
  {
    title: '作業者名',
    dataIndex: 'user_name',
    className: 'boder-left',
  },
  {
    title: '工種',
    dataIndex: 'work_type_name',
    className: 'boder-left',
  },
  {
    title: '所属業者',
    dataIndex: 'cooperator_name',
    className: 'boder-left',
  },
  {
    title: '開始日',
    dataIndex: 'start_date',
    className: 'boder-left',
    render: (record: Date) => {
      return dayjs(record).format('YYYY/MM/DD');
    },
  },
  {
    title: '終了日',
    dataIndex: 'end_date',
    className: 'boder-left',
    render: (record: Date) => {
      return dayjs(record).format('YYYY/MM/DD');
    },
  },
  {
    title: '入退場時刻',
    className: 'boder-left',
    render: (item: Types.UserStatuses) => {
      const enterTime = dayjs(item.enter_stamp);
      const exitTime = dayjs(item.exit_stamp);

      return (
        <>
          {enterTime.isValid() ? enterTime.format('HH:mm') : ''}
          {' - '}
          {exitTime.isValid() ? exitTime.format('HH:mm') : ''}
        </>
      );
    },
  },
  {
    title: 'RKY・安全指示',

    className: 'boder-left',
    render: (item: Types.UserStatuses) => {
      if (typeof item?.rky_check_flag !== 'undefined' && typeof item?.ky_check !== 'undefined') {
        return (
          <CPSubmit
            status={kyStatusCheck({
              ky_check: item?.ky_check,
              safety_order_check_status: item?.safety_order_check_status,
              rky_check_flag: item?.rky_check_flag,
            })}
          />
        );
      }
      return '-';
    },
  },
  // 2025/04/30 Leading Win 匠対応一覧#17 start
  // {
  //   title: '申請体温',
  //   dataIndex: 'body_temperature',
  //   className: 'boder-left',
  //   render: (bodyTemperature: string) => {
  //     return <div>{bodyTemperature ? `${bodyTemperature}°` : '-'}</div>;
  //   },
  // },
  // {
  //   title: '申請血圧',
  //   className: 'boder-left',
  //   render: (data: Types.UserStatuses) => {
  //     return (
  //       <div>
  //         {data?.blood_pressure_min && data?.blood_pressure_min}
  //         {' - '}
  //         {data?.blood_pressure_max && data?.blood_pressure_max}
  //       </div>
  //     );
  //   },
  // },
  // 2025/04/30 Leading Win 匠対応一覧#17 end

  // 2025/02/25 FJ 3月分反映分 NO32 start
  // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
  // {
  //   title: '新規入場者',
  //   className: 'boder-left',
  //   render: (data: Types.UserStatuses) => {
  //     return <div>{educationStatus(data?.newcomer_education_status)}</div>;
  //   },
  // },
  // {
  //   title: '送り出し',
  //   className: 'boder-left',
  //   render: (data: Types.UserStatuses) => {
  //     return <div>{educationStatus(data?.sendoff_education_status)}</div>;
  //   },
  // },
  // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
  // 2025/02/25 FJ 3月分反映分 NO32 end
  {
    render: (record: Types.WorkerStatus, row: any, index: number) => (
      <MenuTable row={record} indexTable={index} />
    ),
    width: '1%',
    className: 'boder-left',
  },
];

const columnsWorkerStatusBo = [
  {
    title: '作業者名',
    dataIndex: 'user_name',
    className: 'boder-left',
  },
  {
    title: '工種',
    dataIndex: 'work_type_name',
    className: 'boder-left',
  },
  {
    title: '入退場時刻',
    className: 'boder-left',
    render: (item: Types.UserStatuses) => {
      const enterTime = dayjs(item.enter_stamp);
      const exitTime = dayjs(item.exit_stamp);

      return (
        <>
          {enterTime.isValid() ? enterTime.format('HH:mm') : ''}
          {' - '}
          {exitTime.isValid() ? exitTime.format('HH:mm') : ''}
        </>
      );
    },
  },
  {
    title: '一次業者',
    dataIndex: 'first_company_name',
    className: 'boder-left',
    render: (item: string, val: any) => (
      // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
      // <>{!val.third_company_name && !val.second_company_name ? item : '-'}</>
      <>{val.first_company_name ? item : '-'}</>
      // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
    ),
  },
  {
    title: '二次業者',
    dataIndex: 'second_company_name',
    className: 'boder-left',
    render: (item: string, val: any) => (
      // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
      // <>{!val.third_company_name && val.second_company_name ? item : '-'}</>
      <>{val.second_company_name ? item : '-'}</>
      // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
    ),
  },
  {
    title: '三次業者',
    dataIndex: 'third_company_name',
    className: 'boder-left',
    render: (item: string, val: any) => <>{val.third_company_name ? item : '-'}</>,
  },
  // 2025/04/30 Leading Win 匠対応一覧#17 start
  // {
  //   title: '申請体温',
  //   dataIndex: 'body_temperature',
  //   className: 'boder-left',
  //   render: (bodyTemperature: string) => {
  //     return <div>{bodyTemperature ? `${bodyTemperature}°` : '-'}</div>;
  //   },
  // },
  // {
  //   title: '申請血圧',
  //   className: 'boder-left',
  //   render: (data: Types.UserStatuses) => {
  //     return (
  //       <div>
  //         {data?.blood_pressure_min && data?.blood_pressure_min} -
  //         {data?.blood_pressure_max && data?.blood_pressure_max}
  //       </div>
  //     );
  //   },
  // },
  // 2025/04/30 Leading Win 匠対応一覧#17 end
  {
    title: 'RKY・安全指示',

    className: 'boder-left',
    render: (item: Types.UserStatuses) => {
      if (typeof item?.rky_check_flag !== 'undefined' && typeof item?.ky_check !== 'undefined') {
        return (
          <CPSubmit
            status={kyStatusCheck({
              ky_check: item?.ky_check,
              safety_order_check_status: item?.safety_order_check_status,
              rky_check_flag: item?.rky_check_flag,
            })}
          />
        );
      }

      return '-';
    },
  },
  // 2025/02/25 FJ 3月分反映分 NO32 start
  // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
  // {
  //   title: '新規入場者',
  //   className: 'boder-left',
  //   render: (data: Types.UserStatuses) => {
  //     return <div>{educationStatus(data?.newcomer_education_status)}</div>;
  //   },
  // },
  // {
  //   title: '送り出し',
  //   className: 'boder-left',
  //   render: (data: Types.UserStatuses) => {
  //     return <div>{educationStatus(data?.sendoff_education_status)}</div>;
  //   },
  // },
  // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
  // 2025/02/25 FJ 3月分反映分 NO32 end
  {
    render: (record: Types.WorkerStatus, row: any, index: number) => (
      <MenuTable row={record} indexTable={index} />
    ),
    width: '1%',
    className: 'boder-left',
  },
];

const columnsWorkRisk = (maxPoint: number, role: any) => [
  {
    title: '作業内容',
    dataIndex: 'item_name',
    className: 'boder-left',
    with: '228px',
  },
  {
    title: '危険ポイント',
    dataIndex: 'dangerpoint_content',
    className: 'boder-left',
    with: '267px',
  },
  {
    title: '具体的な対策',
    dataIndex: 'counterplan_content',
    className: 'boder-left',
    width: role === userRole.BO ? '400px' : '520px',
  },
  ...(role === userRole.BO
    ? [
        {
          title: '確認状況',
          dataIndex: 'check_status',
          render: (status: number) => <CPSubmit status={status} />,
          with: '120px',
        },
      ]
    : []),
  {
    title: 'リスク点数',
    dataIndex: 'risk_point',
    render: (risk_point: number) => <PointRisk point={risk_point} maxPoint={maxPoint} />,
    with: '115px',
  },
];
type PropsSubmit = {
  status: number;
  textCustomConfirm?: string;
  textCustomUnConfirm?: string;
};
const CPSubmit: FC<PropsSubmit> = ({ status, textCustomConfirm, textCustomUnConfirm }) => {
  if (isUndefined(status)) return null;
  const renderColor = () => {
    switch (status) {
      case StatusConfirm.CONFIRMED:
        return {
          color: '#69B362',
          text: textCustomConfirm ? textCustomConfirm : StatusConfirm[status],
        };
      case StatusConfirm.UNCONFIRMED:
        return {
          color: '#E65050',
          text: textCustomUnConfirm ? textCustomUnConfirm : StatusConfirm[status],
        };
      case StatusConfirm.DIRECTED:
        return { color: '#69B362', text: StatusConfirm[status] };
      default:
        return { color: '#E65050', text: StatusConfirm[StatusConfirm.UNCONFIRMED] };
    }
  };
  return <SubmitStyled color={renderColor().color}>{renderColor().text}</SubmitStyled>;
};

const StatusRky: FC<PropsSubmit> = ({ status }) => {
  const renderColor = () => {
    switch (status) {
      case StatusConfirm.CONFIRMED:
        return {
          color: '#69B362',
          text: 'チェック済',
        };
      case StatusConfirm.UNCONFIRMED:
        return {
          color: '#E65050',
          text: '未確認あり',
        };

      default:
        return { color: '#E65050', text: '未確認あり' };
    }
  };

  return (
    <>
      {status == StatusConfirm.DIRECTED ? null : (
        <SubmitStyled color={renderColor().color}>{renderColor().text}</SubmitStyled>
      )}{' '}
    </>
  );
};

type PropsPointRisk = {
  point: number;
  maxPoint: number;
};

const PointRisk: FC<PropsPointRisk> = ({ point, maxPoint }) => {
  return <PointRiskStyled checked={maxPoint === point}>{point}</PointRiskStyled>;
};

type PropsMenuTable = {
  row: Types.WorkerStatus;
  indexTable: number;
};

const MenuTable: FC<PropsMenuTable> = ({ row, indexTable }) => {
  const { getStatusForBuildingDetail, updateRkyCheckStatus, getSiteUserStatusData, fetchApi } =
    React.useContext(actionsCallBack);
  const { SiteCooperatorListToday, Ky, TodaySlingtool, TodayFootingCheck, TodaySafetyOrder } =
    useSelector(siteDetailSelector);
  const { roleUser } = useSelector(userData);
  const [isModalEditCheckInTime, setIsModalEditCheckInTime] = useState<boolean>(false);
  const query = useQueryParams();
  const currentDay = query.get('currentDay') || new Date();
  const dispatch = useAppDispatch();
  const { buildingId } = useParams<{ buildingId: string }>();
  // 2025/02/25 FJ 3月分反映分 NO32 start
  const currentDayParams = query.get('currentDay')
    ? dayjs(query.get('currentDay')).format('YYYY-MM-DD')
    : dayjs().format('YYYY-MM-DD');
  // 2025/02/25 FJ 3月分反映分 NO32 end
  const setRKYStatus = async (data: Types.RkyCheckStatusData) => {
    try {
      await updateRkyCheckStatus(indexTable);
      await fetchApi();
      return;

      // getStatusForBuildingDetail &&
      //   (await getStatusForBuildingDetail({
      //     building_id: buildingId,
      //     date: dayjs(currentDay).format('YYYY-MM-DD'),
      //     cooperator_id: query.get('cooperator_id'),
      //   }));

      // await dispatch(
      //   updateStatusSkyCheck({
      //     id: data.user_id,
      //     changes: { ky_check: 1, safety_order_check_status: 1, rky_check_flag: 1 },
      //   })
      // );

      // if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
      //   dispatch(
      //     getTodaySlingtool({
      //       building_id: buildingId,
      //       today: dayjs(currentDay).format('YYYY-MM-DD'),
      //       cooperator_id: query.get('cooperator_id') ?? '',
      //     })
      //   );
      // } else {
      //   dispatch(
      //     getTodaySlingtoolGroup({
      //       building_id: buildingId,
      //       today: dayjs(currentDay).format('YYYY-MM-DD'),
      //       first_cooperator_code: query.get('cooperator_code') ?? '',
      //     })
      //   );
      // }

      // if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
      //   dispatch(
      //     getTodayFootingCheck({
      //       building_id: buildingId,
      //       today: dayjs(currentDay).format('YYYY-MM-DD'),
      //       cooperator_id: query.get('cooperator_id') ?? '',
      //     })
      //   );
      // } else {
      //   dispatch(
      //     getTodayFootingCheckGroup({
      //       building_id: buildingId,
      //       today: dayjs(currentDay).format('YYYY-MM-DD'),
      //       first_cooperator_code: query.get('cooperator_code') ?? '',
      //     })
      //   );
      // }

      // if (Number(currentDayParams.replaceAll('-', '')) < systemChangeDay) {
      //   // 2023/11/24 Leading Win 作業員シフト表廃止対応 作業日報 start
      //   const resultKy = await dispatch(
      //     getKy({
      //       building_id: buildingId,
      //       date: dayjs(currentDay).format('YYYY-MM-DD'),
      //       cooperator_id: query.get('cooperator_id') ?? '',
      //     })
      //   );

      //   const work_id_list: any = [];
      //   if (getKy.fulfilled.match(resultKy) && resultKy?.payload?.ky_data) {
      //     resultKy.payload.ky_data.map(async (k) => {
      //       if (k.work_type_id) {
      //         work_id_list.push({ work_id: `${k.work_type_id}` });
      //       }
      //     });
      //   }
      //   // 2023/11/24 Leading Win 作業員シフト表廃止対応 作業日報 end
      //   await dispatch(
      //     getTodaySafetyOrder({
      //       building_id: buildingId,
      //       date: dayjs(currentDay).format('YYYY-MM-DD'),
      //       cooperator_id: query.get('cooperator_id') ?? '',
      //       // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 start
      //       work_id_list,
      //       // 2023/11/21 Leading Win 作業員シフト表廃止対応 作業日報 end
      //     })
      //   );
      // } else {
      //   // 2023/11/24 Leading Win 作業員シフト表廃止対応 作業日報 start
      //   const resultKy = await dispatch(
      //     getKyGroup({
      //       building_id: buildingId,
      //       date: dayjs(currentDay).format('YYYY-MM-DD'),
      //       first_cooperator_code: query.get('cooperator_code') ?? '',
      //     })
      //   );

      //   const work_id_list: any = [];
      //   if (getKyGroup.fulfilled.match(resultKy) && resultKy?.payload?.ky_data) {
      //     resultKy.payload.ky_data.map(async (k) => {
      //       if (k.work_type_id) {
      //         work_id_list.push({ work_id: `${k.work_type_id}` });
      //       }
      //     });
      //   }
      //   // 2023/11/24 Leading Win 作業員シフト表廃止対応 作業日報 end
      //   await dispatch(
      //     getTodaySafetyOrderGroup({
      //       building_id: buildingId,
      //       date: dayjs(currentDay).format('YYYY-MM-DD'),
      //       first_cooperator_code: query.get('cooperator_code') ?? '',
      //       work_id_list,
      //     })
      //   );
      // }

      // 2023/11/24 Leading Win 作業員シフト表廃止対応 作業日報 end
    } catch (error) {
      console.error(error);
    }
  };
  const showSlingtoolAndFootingcheck = useCallback(
    ({ all_items_check_status, disuse_check_status }) => {
      let isShowContent = false;
      if (all_items_check_status === 1 || disuse_check_status === 1) {
        isShowContent = true;
      }
      return { isShowContent };
    },
    []
  );
  const kyTodayId = Ky?.data?.ky_id;
  const isToolCheckAllChecked = showSlingtoolAndFootingcheck({
    all_items_check_status: TodaySlingtool.data?.all_items_check_status,
    disuse_check_status: TodaySlingtool.data?.disuse_check_status,
  }).isShowContent;
  const isScaffoldCheckAllChecked = showSlingtoolAndFootingcheck({
    all_items_check_status: TodayFootingCheck.data?.all_items_check_status,
    disuse_check_status: TodayFootingCheck.data?.disuse_check_status,
  }).isShowContent;
  const menu = (
    <Menu>
      {roleUser === userRole.BO ? (
        <Menu.Item className="menu" key={uniqueId()}>
          <div onClick={() => setIsModalEditCheckInTime(true)}>入退場時刻補正</div>
        </Menu.Item>
      ) : (
        <Menu.Item
          key={uniqueId()}
          disabled={!kyTodayId || !isToolCheckAllChecked || !isScaffoldCheckAllChecked}
          className="menu"
        >
          <div
            onClick={() => {
              if (kyTodayId && isToolCheckAllChecked && isScaffoldCheckAllChecked) {
                setRKYStatus({
                  building_id: buildingId,
                  user_id: row.user_id,
                  date: currentDay,
                  today_ky_tables_id: '',
                  cooperator_code:
                    row.third_company_code ||
                    row.second_company_code ||
                    row.first_company_code ||
                    '',
                  first_cooperator_code: row.first_company_code,
                  cooperator_id: row.cooperator_id,
                  first_cooperator_id: query.get('cooperator_id') ?? '',
                  ky_work_id_list:
                    Ky.data?.ky_data.map((item) => ({
                      work_id: item.work_type_id.toString(),
                    })) ?? [],
                });
              }
            }}
          >
            RKY指導済みに変更
            {/* {JSON.stringify(row, null, 2)
              .split('\n')
              .map((line, index) => (
                <div key={index}>{line}</div>
              ))} */}
          </div>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <>
      {roleUser === userRole.BO && (
        <ModalEditCheckInTime
          workerStatus={row}
          visible={isModalEditCheckInTime}
          onCancel={() => {
            setIsModalEditCheckInTime(false);
          }}
          onOk={() => {
            // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
            // dispatch(
            //   getShopSchedulesWorkersChargeSiteList({
            //     building_id: buildingId,
            //     date: dayjs(currentDay).format('YYYY-MM-DD'),
            //   })
            // );
            // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
            SiteCooperatorListToday?.data?.cooperators &&
              // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
              // getSiteUserStatusData(SiteCooperatorListToday.data.cooperators).finally(() =>
              getSiteUserStatusData().finally(() =>
                // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
                setIsModalEditCheckInTime(false)
              );
          }}
        />
      )}
      <Dropdown overlay={menu} placement="bottomLeft">
        <img height="20px" src={other} alt="" />
      </Dropdown>
    </>
  );
};

type PropsCheckTool = {
  status: number | string;
};

const CheckTool: FC<PropsCheckTool> = ({ status }) => {
  const renderText = () => {
    switch (status) {
      // case CheckTools.BAD:
      //   return '否';
      case CheckTools.GOOD:
        return '良';
      case CheckTools.NONE:
        return '-';
      default:
        return '-';
    }
  };
  return <CheckToolStyled status={status}>{renderText()}</CheckToolStyled>;
};
